<template>
  <div>

      <v-dialog v-model="show_editor" max-width="500" persistent>
        <extenedit :item="item_edit" @submit="submitForm" @cancel="cancelForm" :busy="edit_submitting" :group_tags="callPickupTags"></extenedit>
      </v-dialog>

      <v-dialog v-model="show_delete_confirm" max-width="500" persistent>
        <v-card>
          <v-card-title class="headline red lighten-2">
            Confirm Delete
            <v-spacer></v-spacer>
            <v-icon>warning</v-icon>
          </v-card-title>
          <v-card-text class="text-xs-center title">
            <div class="my-4 grey--text">
              Are you sure you want to delete extension {{ ext_to_delete.name }}?
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click="show_delete_confirm = false" :disabled="busy_deleting">Cancel</v-btn>
            <v-btn color="primary" flat @click="deleteExtension" :loading="busy_deleting">Delete</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-container>
        <v-layout justify-center>
          <v-flex fluid>

            <v-card>

              <v-toolbar card class="secondary">
                <v-icon>settings_phone</v-icon>
                <v-spacer></v-spacer>
                <v-btn fab small flat class="mx-0" @click="populateTable">
                  <v-icon>refresh</v-icon>
                </v-btn>
                <v-btn fab small flat class="mx-0" @click="addExtension">
                  <v-icon>add</v-icon>
                </v-btn>
              </v-toolbar>

              <v-alert :value="load_error" type="error" outline class="ma-3">{{ load_error }}</v-alert>

              <v-data-table :headers="headers" :items="items" item-key="name" :loading="loading" :rows-per-page-items="[10,20,50]">
                <template slot="items" slot-scope="props">
                  <tr>
                    <td>{{ props.item.name }}</td>
                    <td class="text-xs-center">
                      <v-icon>{{ getStatusIcon(props.item.state) }}</v-icon>
                    </td>
                    <td>{{ props.item.description }}</td>
                    <td class="text-xs-center">
                      <v-btn icon class="mx-0" @click="editExtension(props.item)">
                        <v-icon color="green">edit</v-icon>
                      </v-btn>
                      <v-btn icon class="mx-0" @click="deleteExtensionConfirm(props.item)">
                        <v-icon color="red">delete</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>

            </v-card>

          </v-flex>
        </v-layout>
      </v-container>

    </div>
</template>

<script>
import extenEdit from './extenedit'
import mx_devstate from '../js/mixins'

export default {
  name: 'extensions',
  mixins: [
    mx_devstate
  ],
  components: {
    extenedit: extenEdit
  },
  sockets: {
    devstate_update: function (dstate) {
      if (dstate.device === undefined) {
        return
      }
      if (!dstate.device) {
        return
      }
      this.items.forEach(function(itm,idx) {
        if (itm.name === dstate.device) {
          let new_item = Object.assign({},itm)
          new_item.state = dstate.status
          this.$set(this.items,idx,new_item)
          return
        }
      },this)
    },
    stream_status: function (d) {
      if (d.status == 'stopped' && this.restart_stopped_stream) {
        this.restart_stopped_stream = false
        this.start_data_stream()
        return
      }

      if (this.stream_tries > 5) {
        return
      }
      if ('status' in d) {
        if (d['status'] == 'error') {
          if ('message' in d) {
            if ((d['message'] == 'Already streaming') || (d['message'] == 'Not logged in')) {
              this.stream_tries += 1
              setTimeout(this.start_data_stream(),200)
            }
          }
        }
      }
    }
  },
  data: () => ({
    load_error: '',
    headers: [
      { text: 'Extension', value: 'name', width: '1%' },
      { text: 'Status', value: 'status', width: '1%', sortable: false, align: 'center' },
      { text: 'Description', value: 'description' },
      { text: 'Actions', sortable: false, align: 'center', width: '15%' }
    ],
    items: [],
    show_editor: false,
    item_edit: {},
    edit_submitting: false,
    submit_error: '',
    show_delete_confirm: false,
    ext_to_delete: '',
    busy_deleting: false,
    stream_tries: 0,
    restart_stopped_stream: false
  }),
  methods: {
    populateTable: function () {
      this.stop_data_stream()

      this.loading = true
      this.load_error = ''
      this.items = []

      this.$api.get('/extenlist',{ params: { account_code: this.account_code }}).then(response => {
        this.items = response.data.data.slice()
        this.loading = false
        this.start_data_stream()
      }).catch(e => {
        this.loading = false
        if (!e.response) {
          this.load_error = 'No response from API server.'
        } else {
          this.load_error = 'Error loading table data (error ' + e.response.status + ')'
        }
      })
    },
    addExtension: function () {
      this.item_edit = {}
      this.edit_submitting = false
      this.show_editor = true
    },
    editExtension: function (item) {
      this.item_edit = Object.assign({},item)
      this.edit_submitting = false
      this.show_editor = true
    },
    deleteExtensionConfirm: function (item) {
      this.ext_to_delete = item
      this.show_delete_confirm = true
    },
    deleteExtension: function () {
      this.busy_deleting = true
      let ext_name = this.ext_to_delete.name
      this.$api.delete('/extendel/' + ext_name).then(response => {
        this.show_delete_confirm = false
        this.busy_deleting = false

        var idx = -1
        for (var i = 0; i < this.items.length; i++) {
          if (this.items[i].name == ext_name) {
            idx = i
            break
          }
        }
        if (idx > -1) {
          this.items.splice(idx,1)
        }
      }).catch(e => {
        this.show_delete_confirm = false
        this.busy_deleting = false
        if (e.response) {
          this.load_error = "Error deleting extension (" + e.response.status + ')'
        } else if (error.request) {
          this.load_error = "Timeout while deleting extension."
        } else {
          this.load_error = "Error deleting extension."
        }
      })
    },
    submitForm: function (submit_rec) {
      let rec = {}
      Object.keys(submit_rec.data).forEach(function(fld) {
        if (fld === 'name') {
          rec['name'] = this.branch_code + submit_rec.data['name']
          return
        }
        rec[fld] = submit_rec.data[fld]
      },this)
      rec.account_code = this.account_code

      let url = null
      let api_method = 'put'
      if (submit_rec.new_record) {
        url = '/extenadd'
        api_method = 'post'
      } else {
        url = '/extenupd/' + rec.name
      }

      this.edit_submitting = true

      this.$api[api_method](url,rec).then(response => {
        this.edit_submitting = false
        this.show_editor = false
        if (submit_rec.new_record) {
          if ('exten_id' in response.data.data) {
            rec.id = response.data.data['exten_id']
          }
          this.items.push(rec)
        } else {
          let updrec_idx = -1
          for (var i = 0; i < this.items.length; i++) {
            if (this.items[i].name === rec.name) {
              updrec_idx = i
              break
            }
          }
          if (updrec_idx >= 0) {
            this.$set(this.items,updrec_idx,rec)
          }
        }
      }).catch(e => {
        this.edit_submitting = false
        if (!e.response) {
          this.submit_error = 'No response from API server'
        } else {
          this.submit_error = 'Error saving record (error ' + e.response.status + ')'
        }
      })
    },
    cancelForm: function () {
      this.show_editor = false
    },
    start_data_stream: function () {
      let user = this.$store.getters.auth_user
      let acc = user
      if (user === 'admin') {
        acc = this.account_code
      }

      this.$socket.emit('start_data_stream',acc,'devstate')
    },
    stop_data_stream: function () {
      this.$socket.emit('stop_data_stream')
    }
  },
  watch: {
    account_code: function () {
      this.populateTable()
      // this.restart_stopped_stream = true
      // this.stop_data_stream()
    }
  },
  computed: {
    account_code: function () {
      if (this.$store.getters.auth_user === 'admin') {
        return this.$store.state.admin_selacc
      }
      return this.$store.getters.auth_data['account_code']
    },
    branch_code: function () {
      return this.$store.getters.auth_branch_code
    },
    callPickupTags: function () {
      let obj = {}
      this.items.forEach(function(itm) {
        if ('callgroups' in itm) {
          itm.callgroups.forEach(function(grp) {
            obj[grp] = true
          })
        }
        if ('pickupgroups' in itm) {
          itm.pickupgroups.forEach(function(grp) {
            obj[grp] = true
          })
        }
      })

      return Object.keys(obj)
    }
  },
  beforeMount: function() {
    this.populateTable()
    // this.start_data_stream()
  },
  beforeDestroy: function () {
    this.stop_data_stream()
  }
}
</script>

<style scoped>
</style>
